import { RiErrorWarningLine } from 'react-icons/ri';
import { useField } from 'formik';
import ModalInfo from './modalInfo';

export default function FormSelect({
  label,
  name,
  options,
  required = true,
  ...props
}) {
  const [field, meta] = useField(name);
  const error = meta.touched && meta.error ? meta.error : null;

  return (
    <label className="relative w-full">
      <div className="flex items-center justify-between">
        <p>{label}</p>
        {required && (
          <ModalInfo
            icon={<RiErrorWarningLine />}
            content="Campo Obrigatório!"
          />
        )}
      </div>

      <select
        className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white border rounded transition ease-in-out focus:outline-none focus:border-blue-600 ${
          error ? 'border-red-500' : 'border-gray-300'
        }`}
        {...field}
        {...props}
        name={name}
      >
        <option value="">Selecione uma opção...</option>
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>

      {error && (
        <p className="text-red-500 text-xs font-medium mt-1">
          {meta.error}
        </p>
      )}
    </label>
  );
}

